'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/rest-resource/~/axios/lib/cancel/isCancel.js
// module id = DA4r
// module chunks = 0